import Swal from "sweetalert2";

const injectOnce = (id, css) => {
  if (document.getElementById(id)) return;
  const style = document.createElement("style");
  style.id = id;
  style.innerHTML = css;
  document.head.appendChild(style);
};

/* =========================
   SUCCESS
========================= */
export const swalSuccess = (message, options = {}) => {
  const color = options.color || "#22c55e";
  const bordercolor = options.color || "#E4F4DA";

  injectOnce(
    "swal-success-style",
    `
    .swal-success-custom .swal2-icon {
      border: none !important;
      background: transparent !important;
    }

    .swal-success-custom .swal2-success-ring,
    .swal-success-custom .swal2-success-line-tip,
    .swal-success-custom .swal2-success-line-long {
      display: none !important;
    }

    .swal-success-custom .swal-circle {
      width: 60px;
      height: 60px;
      border: 3px solid ${bordercolor};
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      animation: flipIn 0.6s ease-out;
    }

    .swal-success-custom .swal-check {
      width: 36px;
      height: 36px;
      stroke: ${color};
      stroke-width: 2.5;
      animation: checkPop 0.4s ease-out 0.2s both;
    }

    @keyframes flipIn {
      from {
        transform: rotateY(90deg) scale(0.6);
        opacity: 0;
      }
      to {
        transform: rotateY(0) scale(1);
        opacity: 1;
      }
    }

    @keyframes checkPop {
      from {
        transform: scale(0.5);
        opacity: 0;
      }
      to {
        transform: scale(1);
        opacity: 1;
      }
    }
    `
  );

  return Swal.fire({
    title: "Sukses!",
    text: message,
    customClass: {
      popup: "swal-success-custom",
    },
    iconHtml: `
      <div class="swal-circle">
        <svg class="swal-check" fill="none" viewBox="0 0 24 24">
          <path stroke-linecap="round"
                stroke-linejoin="round"
                d="M5 13l4 4L19 7" />
        </svg>
      </div>
    `,
    showCancelButton: false,
    confirmButtonColor: "#1A56DB",
    confirmButtonText: "Ok!",
  });
};

/* =========================
   ERROR (DEFAULT)
========================= */
/* =========================
   ERROR (CUSTOM)
========================= */
export const swalError = (message, options = {}) => {
  const color = options.color || "#ef4444"; // merah
  const borderColor = options.borderColor || "#FEE2E2"; // merah muda

  injectOnce(
    "swal-error-style",
    `
    /* SCOPE KHUSUS ERROR */
    .swal-error-custom .swal2-icon {
      border: none !important;
      background: transparent !important;
    }

    .swal-error-custom .swal2-error-ring,
    .swal-error-custom .swal2-error-line {
      display: none !important;
    }

    /* LINGKARAN */
    .swal-error-custom .swal-circle {
      width: 60px;
      height: 60px;
      border: 3px solid ${borderColor};
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      animation: flipIn 0.6s ease-out;
    }

    /* ICON X */
    .swal-error-custom .swal-x {
      width: 34px;
      height: 34px;
      stroke: ${color};
      stroke-width: 2.5;
      animation: xPop 0.4s ease-out 0.2s both;
    }

    @keyframes flipIn {
      from {
        transform: rotateY(90deg) scale(0.6);
        opacity: 0;
      }
      to {
        transform: rotateY(0) scale(1);
        opacity: 1;
      }
    }

    @keyframes xPop {
      from {
        transform: scale(0.5);
        opacity: 0;
      }
      to {
        transform: scale(1);
        opacity: 1;
      }
    }
    `
  );

  return Swal.fire({
    title: "Gagal",
    text: message,
    customClass: {
      popup: "swal-error-custom",
    },
    iconHtml: `
      <div class="swal-circle">
        <svg class="swal-x" fill="none" viewBox="0 0 24 24">
          <path stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18L18 6M6 6l12 12" />
        </svg>
      </div>
    `,
    confirmButtonColor: "#DC2626",
    confirmButtonText: "OK",
  });
};

/* =========================
   WARNING (DEFAULT)
========================= */
export const swalWarning = (message) => {
  return Swal.fire({
    icon: "warning",
    title: "Perhatian",
    text: message,
    confirmButtonText: "OK",
  });
};

/* =========================
   SUCCESS + COPY (CUSTOM)
========================= */
export const swalSuccessCopy = (message, options = {}) => {
  const color = options.color || "#22c55e";
  const borderColor = options.borderColor || "#E4F4DA";
  const subtitle = options.subtitle || "Silahkan salin password baru di atas";

  injectOnce(
    "swal-success-copy-style",
    `
    .swal-success-copy-custom .swal2-icon {
      border: none !important;
      background: transparent !important;
    }

    .swal-success-copy-custom .swal2-success-ring,
    .swal-success-copy-custom .swal2-success-line-tip,
    .swal-success-copy-custom .swal2-success-line-long {
      display: none !important;
    }

    .swal-success-copy-custom .swal-circle {
      width: 60px;
      height: 60px;
      border: 3px solid ${borderColor};
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      animation: flipIn 0.6s ease-out;
      margin: 0 auto;
    }

    .swal-success-copy-custom .swal-check {
      width: 36px;
      height: 36px;
      stroke: ${color};
      stroke-width: 2.5;
      animation: checkPop 0.4s ease-out 0.2s both;
    }

    @keyframes flipIn {
      from {
        transform: rotateY(90deg) scale(0.6);
        opacity: 0;
      }
      to {
        transform: rotateY(0) scale(1);
        opacity: 1;
      }
    }

    @keyframes checkPop {
      from {
        transform: scale(0.5);
        opacity: 0;
      }
      to {
        transform: scale(1);
        opacity: 1;
      }
    }
    `
  );

  return Swal.fire({
    title: `<strong>${message}</strong>`,
    text: subtitle,
    customClass: {
      popup: "swal-success-copy-custom",
    },
    iconHtml: `
      <div class="swal-circle">
        <svg class="swal-check" fill="none" viewBox="0 0 24 24">
          <path stroke-linecap="round"
                stroke-linejoin="round"
                d="M5 13l4 4L19 7" />
        </svg>
      </div>
    `,
    showCancelButton: false,
    showDenyButton: true,
    confirmButtonText: "Salin",
    denyButtonText: "Tutup",
    confirmButtonColor: "#1A56DB",
  }).then((result) => {
    if (result.isConfirmed) {
      navigator.clipboard
        .writeText(message)
        .then(() => {
          console.log("Password berhasil disalin ke clipboard!");
        })
        .catch((err) => {
          console.error("Gagal menyalin teks:", err);
        });
    }

    options.onClose?.(result);
  });
};
